module.exports = __webpack_public_path__ + "static/porch-shades-1529546ea352f9cd17c5e83f40bb0599.png";